import React, { useCallback, useMemo } from "react";
import { postiesPageTypes, useSdkContext } from "~/components/contexts";
import { MyNewsCompletionPopup } from ".";
export const useMyNewsCompletionPopupGetter = options => {
  var _popupState$myNews$co2, _popupState$myNews4;
  const {
    acquisition: {
      popupState
    },
    currentPageType,
    hasEnoughFollowedItems,
    initialHasEnoughFollowedItems
  } = useSdkContext();
  const needToDisplay = useMemo(() => {
    var _popupState$myNews$co;
    return (
      // 1. Is not posties pages
      !postiesPageTypes.includes(currentPageType) && ( // 2. Drupal Config is on
      (_popupState$myNews$co = popupState.myNews.config) === null || _popupState$myNews$co === void 0 || (_popupState$myNews$co = _popupState$myNews$co.completion_popup) === null || _popupState$myNews$co === void 0 ? void 0 : _popupState$myNews$co.isEnabled) &&
      // 3. Is Logged in
      options.isLoggedIn &&
      // 4. Followed items length is larger than threshold
      hasEnoughFollowedItems &&
      // 5. Snapshot list length is not larger than threshold (So if the user already followed more than threshold in the beginning, the popup will not show)
      !initialHasEnoughFollowedItems
    );
  }, [currentPageType, hasEnoughFollowedItems, initialHasEnoughFollowedItems, options.isLoggedIn, (_popupState$myNews$co2 = popupState.myNews.config) === null || _popupState$myNews$co2 === void 0 || (_popupState$myNews$co2 = _popupState$myNews$co2.completion_popup) === null || _popupState$myNews$co2 === void 0 ? void 0 : _popupState$myNews$co2.isEnabled]);
  const getNextFromConfig = useCallback(handleClose => {
    var _popupState$myNews, _popupState$myNews2, _popupState$myNews3;
    if (!((_popupState$myNews = popupState.myNews) !== null && _popupState$myNews !== void 0 && _popupState$myNews.completion) || !needToDisplay) return;
    const localStorageKey = (_popupState$myNews2 = popupState.myNews) === null || _popupState$myNews2 === void 0 || (_popupState$myNews2 = _popupState$myNews2.completion) === null || _popupState$myNews2 === void 0 ? void 0 : _popupState$myNews2.localStorageKey;
    const hasAlreadyShown = localStorage.getItem(localStorageKey) !== null;
    if (hasAlreadyShown) return;
    const props = {
      config: (_popupState$myNews3 = popupState.myNews) === null || _popupState$myNews3 === void 0 ? void 0 : _popupState$myNews3.completion,
      modalContainerReference: options.modalContainerReference,
      onClose: handleClose
    };
    return {
      element: /*#__PURE__*/React.createElement(MyNewsCompletionPopup, props),
      localStorageKey
    };
  }, [needToDisplay, options.modalContainerReference, (_popupState$myNews4 = popupState.myNews) === null || _popupState$myNews4 === void 0 ? void 0 : _popupState$myNews4.completion]);
  const getters = useMemo(() => ({
    getNextFromConfig
  }), [getNextFromConfig]);
  return getters;
};